<template>
  <div class="container ">
    <div class="header">
      <van-nav-bar :title="$t('personalreport.title')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="info">
        <p class="title">{{ $t("personalreport.profit") }}</p>
        <p class="value">{{ this.win_money.toFixed(2) }}</p>
        <p class="tip">{{ $t("personalreport.formula") }}</p>
      </div>
    </div>
    <div class="content">
      <div class="datalist">
        <div class="datalistitem">
          <div class="datalistitemValue">{{ this.personalreport.play_money }}</div>
          <div class="datalistitemKey">{{ $t("personalreport.task") }}</div>
          <div class="datalistitemRightLine"></div>
        </div>
        <div class="datalistitem">
          <div class="datalistitemValue">{{ this.personalreport.recharge}}</div>
          <div class="datalistitemKey">{{ $t("personalreport.recharge") }}</div>
          <div class="datalistitemRightLine"></div>
        </div>
        <div class="datalistitem">
          <div class="datalistitemValue">{{ this.personalreport.withdrawal }}</div>
          <div class="datalistitemKey">{{ $t("personalreport.withdrawal") }}</div>
          <div class="datalistitemRightLine"></div>
        </div>
        <div class="datalistitem">
          <div class="datalistitemValue">{{ this.personalreport.win_money }}</div>
          <div class="datalistitemKey">{{ $t("personalreport.win_money") }}</div>
          <div class="datalistitemRightLine"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      win_money:0,
      personalreport:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getPersonalreport(){
      this.$http({
        method: 'get',
        url: 'user_get_personalreport'
      }).then(res=>{
        if(res.code === 200){
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getPersonalreport();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

</style>
